import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import ApplicantVerified from './ApplicantVerified';
import VerifyApplicant from './VerifyApplicant';
import ContinueButton from '../../../common/components/Buttons/ContinueButton';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
    },
    button: {
        marginLeft: unit * 2,
    },
    buttons: {
        marginTop: unit * 2,
        marginBottom: unit * 2,
    },
    formControl: {
        marginTop: unit * 3,
        minWidth: unit * 26,
        '&:not(:last-of-type)': {
            marginRight: unit * 3,
        },
    },
});
function ApplicantIdVerification(props) {
    const goToNextStep = () => {
        props.setStep(7);
        props.setStepCompleted(6, true);
    };
    return (
        <div className={props.classes.root}>
            {props.verified &&
                <ApplicantVerified
                    photoUrl={props.photoUrl}
                />
            }
            {!props.verified &&
                <VerifyApplicant
                    applicant={props.applicant}
                    scannedId={props.scannedId}
                    takenPhoto={props.takenPhoto}
                    setApplicantScannedId={props.setApplicantScannedId}
                    setApplicantTakenPhoto={props.setApplicantTakenPhoto}
                    photoUrl={props.photoUrl}
                />
            }
            <div className={props.classes.buttons}>
                <Button
                    className={props.classes.button}
                    color="default"
                    onClick={() => {
                        props.setStep(6);
                        props.setStepCompleted(7, false);
                    }}
                >
                    Back
                </Button>
                {!props.verified &&
                    <ContinueButton
                        className={props.classes.button}
                        disabled={!props.scannedId || !props.takenPhoto}
                        onClick={() => {
                            props.setVerification(true);
                        }}
                    >
                        Verify
                    </ContinueButton>
                }
                {props.verified &&
                    <ContinueButton
                        className={props.classes.button}
                        disabled={!props.scannedId || !props.takenPhoto}
                        onClick={() => {
                            goToNextStep();
                        }}
                    />
                }
            </div>
        </div>
    );
}

ApplicantIdVerification.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    applicant: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    scannedId: PropTypes.bool.isRequired,
    takenPhoto: PropTypes.bool.isRequired,
    verified: PropTypes.bool.isRequired,
    setApplicantScannedId: PropTypes.func.isRequired,
    setApplicantTakenPhoto: PropTypes.func.isRequired,
    setVerification: PropTypes.func.isRequired,
    photoUrl: PropTypes.string.isRequired,
};

export default withStyles(styles)(ApplicantIdVerification);



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/components/ApplicantIdVerification.js